import {withDialogTitle} from './withDialogTitle';
import {DialogTitleStyle} from './DialogTitleStyle';

/**
 * First component to be rendered in your Dialog component.
 *
 * @component
 */
export const DialogTitle = withDialogTitle(DialogTitleStyle);
